module.exports = __webpack_public_path__ + "static/media/serena.4e630049.png";